module.exports = __webpack_public_path__ + "img/antes_despues_84.39af2480.png";